import React from 'react';
import Chat from 'app/components/Chat';
import SurveyStatistics from 'app/components/SurveyStatistics';
import MainPageDescription from 'app/components/MainPageDescription';
import PromoActions from 'site_version/com/aside/PromoActions';
import LootboxAside from './aside/LootboxAside';
import HiddenTemple from 'site_version/com/aside/HiddenTemple';
import {checkingPages, isDesktopLarge} from 'app/utils';
import AsideStories from 'site_version/com/AsideStories';
import Giveaway from 'site_version/com/Giveaway';
import CasinoWins from 'site_version/com/CasinoWins';
import SocialsList from 'site_version/common/aside/SocialsList';
import Apps from 'site_version/common/aside/Apps';
import ArticleAside from 'site_version/common/aside/ArticleAside';
import {isCasinoPage} from 'app/utils/IsCasinoPage';
import ProomPoker from 'app/components/pages/poker/ProomPoker';
import CupAside from 'app/components/pages/cup/CupAside';
import banners from './aside/Banners';
import {configStore} from 'app/store/global';
import {i18n_t} from 'app/i18n';

type AsideNewBlocksProps = {
    hideChat?: boolean;
};

const AsideNewBlocks = ({hideChat}: AsideNewBlocksProps): React.ReactElement => {
    const inRightOnly = !isDesktopLarge();
    const showWidgets = inRightOnly && !configStore.isDevelopment;
    const isHomePage = checkingPages.isHomePage();

    return <>
        <AsideStories/>
        <PromoActions/>
        {!hideChat && <Chat/>}
        {showWidgets && <CupAside/>}
        {showWidgets && <ProomPoker embedded/>}
        {!isHomePage && <ArticleAside type="promotions" title={i18n_t('promotions_title')}/>}
        {!isHomePage && <ArticleAside type="news" title={i18n_t('news_title')}/>}
        <Giveaway itemClassName="giveaway"/>
        {inRightOnly && <LootboxAside/>}
        <SurveyStatistics/>
        <HiddenTemple/>
        <SocialsList/>
        {isCasinoPage() && <CasinoWins/>}
        {!configStore.MOBILE_WRAPPER && <Apps/>}
        {!isHomePage && <MainPageDescription/>}
        {banners()}
    </>;
};

export default AsideNewBlocks;
